import { Button, Checkbox, Icon, Input, Tooltip } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alertWarning } from '../../../../services/dialog';
import { fieldRequiredItems as fieldRequiredItemsConst, fieldRomaji } from '../../../../services/fieldRequired';
import InputFormat from './../../../../components/input-format';
import lang from './../../../../languages/en';
import { CheckFullSizeHalfSize, trimData } from './../../../../services/helper';
import OrderHelper from './../../../../services/orderHelper';
import { regexExcludeNumber, regexIsRomanji } from './../../../../services/ruleValidate';
import Storage from './../../../../services/Storage';
import { orderStatus } from '../../../../constants';
import { ListChannel } from './../../../../constants/setting_channel';
import { checkContainProhibitedItem } from './../../../../services/prohibitedHelper';
import ToolTipWarringProhibited from "./ToolTipWarringProhibited";
import { getDetailItemNameMaster } from "./../../../../utils/getDetailItemNameMaster";
import hanldeException from './../../../../services/handleException';
import { ListChannel as ListChannelCost } from "./../../../../constants/setting_channel";
import './RowItem.css';
import { isArray } from 'util';

class RowItemComponent extends Component {   
    constructor(props) {
        super(props);
        let { information: { channel_short_name } } = this.props.order;
        this.state = {
            clickInsideToolTipWarring: false,
            clickInsideItemName: false,
            isFisrtTimeLoad: true,
            channel_short_name: channel_short_name,
            toogle: true,
        }
    }
    onChangeClickInSite = (column, value) => {
        this.setState({
            [column]: value
        })
    }
    // static getDerivedStateFromProps = (props, state) => {
    //     let { information: { channel_short_name } } = props.order;
    //     if (channel_short_name !== state.channel_short_name) {
    //         this.onBlur(props.itemData['channel_order_item'], 'channel_order_item')
    //         return {
    //             channel_short_name: channel_short_name
    //         }
    //     }
    // }
    componentDidMount(){
        let { itemData } = this.props;
        this.checkNameItem(itemData, itemData.item_name, 'item_name', this.state.isFisrtTimeLoad)
    }
    onChange = (value, column, maxLength) => {
        let items = [...this.props.itemOrder]
        let deleteDisable = true
        let checked = []
        const { order } = this.props

        if (fieldRomaji.indexOf(column) === -1 || column === 'item_name') {
            let wordMax = CheckFullSizeHalfSize(value, maxLength)
            if (!wordMax) return;
        }

        items.map((item, keyRow) => {
            if (item.key === this.props.itemData.key) {
                if (column === 'origin' && value && !regexIsRomanji(value)) {
                    if (value.trim() === "") {
                        item[column] = value
                        this.props.onChangeItem(items)
                    }
                    return
                }
                if (column === 'price_adjusted') {
                    if (typeof item.orgData === 'object' && item.orgData.is_discount && item.orgData.price_adjusted === value) {
                        item['item_value'] = item.orgData.item_value;
                        item['price_adjustment'] = item.orgData.price_adjustment;
                        item['is_discount'] = item.orgData.is_discount;
                    } else {
                        // value = OrderHelper.roundNumber(value);
                        item['item_value'] = value;//(item['item_value'] && item.id) ? item['item_value'] : value;
                        item['price_adjustment'] = 0;//OrderHelper.roundNumber(item['item_value'] - value);
                        item['is_discount'] = false;
                    }
                }
                item[column] = value;
            }
            if (item.checked && column === 'checked') {
                checked.push(item)
            }
            return item
        })
        if (checked.length === items.length) {
            this.props.checkedAllItems({ items, checked_all: true })
        } else {
            this.props.checkedAllItems({ items, checked_all: false })
        }
        if (column === 'checked') {
            if (checked.length > 0) {
                deleteDisable = false
            } else {
                deleteDisable = true
                this.props.checkedAllItems({ items, checked_all: false })
            }

            this.props.onChange({ value: deleteDisable, column: 'deleteDisable' })
        }
        this.props.onChangeItem(items)
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
    }

    clearError = () => {
        const { itemData } = this.props
        const errorOrder = this.props.order.error

        let indexOrigin = errorOrder.indexOf('origin' + itemData.key)
        let indexItemName = errorOrder.indexOf('item_name' + itemData.key)

        if (indexOrigin !== -1) {
            errorOrder.splice(indexOrigin, 1)
        }

        if (indexItemName !== -1) {
            errorOrder.splice(indexItemName, 1)
        }

        this.props.onChange({ value: errorOrder, column: 'error' })
    }

    removeRowItem = keyItemRemove => {
        let items = [...this.props.itemOrder]

        let itemNew = items.filter((item, keyRow) => {
            return item.key !== this.props.itemData.key
        })

        this.clearError()

        this.props.onChangeItem(itemNew)
    }

    saveRowItem = (checkCancel) => {
        const { itemData, order, itemOrder } = this.props
        let classItem = itemData.classes
        let errorRowItem = order.rowItemError
        let checkRow = []
        let indexRowItem = errorRowItem.indexOf('rowItemError' + itemData.key)

        for (let i = 0; i < itemOrder.length; i++) {
            if (itemData.key === itemOrder[i]['key']) {
                itemOrder[i] = this.validateOrigin(itemOrder[i], itemOrder[i].origin, 'origin')
                itemOrder[i] = this.checkNameItem(itemOrder[i], itemOrder[i].item_name, 'item_name')
            }
        }

        for (let i in classItem) {
            if (classItem[i] === "error") {
                if (!order.dumplicateValueItem) {
                    checkRow.push('error')
                } else {
                    this.props.onChange({ value: 0, column: 'dumplicateValueItem' })
                    return
                }
            }
        }

        if (checkRow.length >= 1) {
            if (indexRowItem === -1) {
                errorRowItem.push('rowItemError' + itemData.key)
            }
        } else {
            if (indexRowItem !== -1) {
                errorRowItem.splice(indexRowItem, 1)
            }
        }

        this.props.onChange({ value: errorRowItem, column: 'rowItemError' })
        this.props.onChangeItem(itemOrder)
        this.onChange(true, 'save_item')
    }

    filterOriginExist = (value) => {
        let listCountry = Storage.get('countries')

        let countryValue = listCountry.filter((item, key) => {
            return item.CountryCode === value
        })

        return countryValue.length
    }

    validateOrigin = (itemRow, value, column) => {
        const { itemData } = this.props
        let errorOrder = this.props.order.error
        let index = errorOrder.indexOf('origin' + itemData.key)
        let countryLength = this.filterOriginExist(value)

        if (!value || countryLength >= 1) {
            if (index !== -1) {
                errorOrder.splice(index, 1)
            }
            itemRow['classes'][column] = ''
        } else {
            let message = lang.origin_existed

            if (index === -1) {
                errorOrder.push('origin' + itemData.key)
            }

            itemRow['classes'][column] = 'error'
            this.props.onChange({ value: message, column: 'message' })
        }

        this.props.onChange({ value: errorOrder, column: 'error' })

        return itemRow
    }

    checkNameItem = (itemRow, value, column, isFirstTimeLoad = false) => {
        const { itemData, prohibitedItems } = this.props
        let errorOrder = this.props.order.error

        let index = errorOrder.indexOf('item_name' + itemData.key)
        let ProhibitedKeyWord = [];
        if (isFirstTimeLoad) {
            ProhibitedKeyWord = itemData.ProhibitedKeyWord;
        } else {
            ProhibitedKeyWord = checkContainProhibitedItem(value, prohibitedItems)
        }
        if (!value || !regexIsRomanji(value) || (isArray(ProhibitedKeyWord) && ProhibitedKeyWord.length > 0)) {
            if (!value || !regexIsRomanji(value)) {
                if (index === -1) {
                    errorOrder.push('item_name' + itemData.key)
                }
                itemRow['classes'][column] = 'error'
            } else if (ProhibitedKeyWord.length > 0){
                if (index !== -1) {
                    errorOrder.splice(index, 1)
                }
                if (!itemData.HasApproveKeyWordBLOrigin) {
                    itemRow['classes'][column] = 'warring';
                } else {
                    itemRow['classes'][column] = '';
                }
                itemRow['ProhibitedKeyWord'] = ProhibitedKeyWord;
            }
        } else {
            if (index !== -1) {
                errorOrder.splice(index, 1)
            }
            itemRow['classes'][column] = '';
            itemRow['ProhibitedKeyWord'] = [];
            itemRow['HasApproveKeyWordBL'] = false;
        }

        this.props.onChange({ value: errorOrder, column: 'error' })
        return itemRow
    }

    onBlur = (value, column) => {
        let items = this.props.itemOrder
        let data = this.props.itemData
        let errorOrder = this.props.order.error
        let prohibitedItems = this.props.prohibitedItems
        let orderMessage = this.props.order.message;
        let orderInfomation = this.props.order.information;
        let fieldRequiredItemsTemp = [...fieldRequiredItemsConst ];
        if (orderInfomation.channel_short_name !== ListChannel.AMAZON_JP.ShortName) {
            //remove require channel_order_item
            let index = fieldRequiredItemsTemp.indexOf('channel_order_item');
            if (index !== -1) fieldRequiredItemsTemp.splice(index, 1)
        }
        value = trimData(value)

        if (typeof value === 'string' && regexIsRomanji(value) && column === 'origin') {
            value = value.toUpperCase()
        }

        for (let i = 0; i < items.length; i++) {
            if (items[i].key === data.key) {
                if (fieldRequiredItemsTemp.indexOf(column) !== -1) {
                    if (!value || value === undefined) {
                        items[i]['classes'][column] = 'error'
                    } else {
                        items[i]['classes'][column] = ''
                    }
                } else {
                    items[i]['classes'][column] = ''
                }
                if (fieldRomaji.indexOf(column) !== -1 && value) {
                    if (!regexIsRomanji(value)) {
                        items[i]['classes'][column] = 'error'
                    } else {
                        items[i]['classes'][column] = ''
                    }

                    if (column === 'item_name') {
                        items[i] = this.checkNameItem(items[i], value, column)
                    }
                }
                if (column == 'sku' && value && !items[i]['classes'][column]) {
                    if (value.length > this.props.maxSizeSku) {
                        items[i]['classes'][column] = 'error'
                    } else {
                        items[i]['classes'][column] = '';
                    }
                }
                if (column === 'origin') {
                    items[i] = this.validateOrigin(items[i], value, column)
                } else if (column === 'price_adjusted') {
                    if (parseFloat(value) === 0) {
                        items[i]['classes'][column] = 'error';
                    }
                }

                items[i][column] = value
                if (column === "sku") {
                    let item_temp = this.searchItemNameMaster(value, items[i]).then(result => {
                        this.setState({
                            toogle: !this.setState.toogle
                        })
                    })
                }
            }
        }

        if (column === 'sku' || column === 'channel_order_item') {
            this.onCheckDumplicate(value, column, 'blur')
        }
        this.props.onChangeItem(items)
        this.props.onChange({ value: errorOrder, column: 'error' })
        if (column === 'item_name') {
            this.setState({
                clickInsideItemName: false
            })

            let ProhibitedKeyWord = checkContainProhibitedItem(value, prohibitedItems)
            if (!ProhibitedKeyWord.length || !isArray(orderMessage)) {
                this.props.onChange({ value: '', column: 'tooltip' })
            }
        } else {
            this.props.onChange({ value: '', column: 'tooltip' })
        }
    
       
    }

    async searchItemNameMaster(sku, item) {
        let { order: { information : {channel_id}}, order } = this.props;
        if ( !sku ) return item
        let payload = {
            sku: sku,
            channelId: channel_id
        }
        try {
            const result = await getDetailItemNameMaster (payload)
            if (result && result.data && result.data.code === 10001) {
                const item_res = result.data.data
                if (item_res.ID) {
                    item = this.fillItem(item, item_res);
                }
            } else {
                hanldeException(result)
            }
        } catch (error) {
            hanldeException(error)
        }
        return item;
    }

    fillItem (item, itemName) {
        let errorOrder = this.props.order.error
        let itemOriginFill = itemName.CountryOfOriginCH && typeof itemName.CountryOfOriginCH === 'string' ? itemName.CountryOfOriginCH.trim() : itemName.CountryOfOriginCH
        let { information : { channel_short_name }, prohibitedItems } = this.props.order;
        if (itemName.SKU) {
            item.item_code = itemName.ItemCode && typeof itemName.ItemCode === 'string' ? itemName.ItemCode.trim() : itemName.ItemCode
            item.item_name = itemName.ItemName_US && typeof itemName.ItemName_US === 'string' ? itemName.ItemName_US.trim() : itemName.ItemName_US
            item.origin = itemOriginFill
            item.price_adjusted = itemName.OriginalPriceFL
            && typeof itemName.OriginalPriceFL === 'string' ? itemName.OriginalPriceFL.trim() : itemName.OriginalPriceFL
            item.HasApproveKeyWordBL = itemName.HasApproveKeyWordBL;
            item.ProhibitedKeyWord =  itemName.ProhibitedKeyWord
        } else {
            item.HasApproveKeyWordBL = false;
            itemName.ProhibitedKeyWord = item.ProhibitedKeyWord;
        }
       

        let countries = Storage.get('countries')
        let countriesNew = []
        for (let j = 0; j < countries.length; j++) {
            countriesNew.push(countries[j]['CountryCode'])
        }

        let index = errorOrder.indexOf('origin' + item.key)
        
        if (!itemOriginFill || (countriesNew.indexOf(itemOriginFill) !== -1)) {
            if (index !== -1) {
                errorOrder.splice(index, 1)
            }
            item.classes.origin = ''
        } else {
            if (index === -1) {
                errorOrder.push('origin' + item.key)
            }
            item.classes.origin = 'error'
        }

        for (let m = 0; m < fieldRomaji.length; m++) {
            if (item[fieldRomaji[m]]) {
                if (!regexIsRomanji(item[fieldRomaji[m]])) {
                    item.classes[fieldRomaji[m]] = 'error'
                } else {
                    item.classes[fieldRomaji[m]] = ''
                }

                if (fieldRomaji[m] === 'item_name') {
                    let indexField = errorOrder.indexOf(fieldRomaji[m] + item.key)

                    if (!regexIsRomanji(item[fieldRomaji[m]])) {
                        item.classes[fieldRomaji[m]] = 'error'
                        if (indexField === -1) {
                            errorOrder.push(fieldRomaji[m] + item.key)
                        }
                    } else {
                        item.classes[fieldRomaji[m]] = ''
                        if (indexField !== -1) {
                            errorOrder.splice(indexField, 1)
                        }
                    }
                }
            }
        }
        
        for (let k = 0; k < fieldRequiredItemsConst.length; k++) {
            if (!item[fieldRequiredItemsConst[k]]
                || (fieldRequiredItemsConst[k] === 'channel_order_item'
                    && !regexIsRomanji(item[fieldRequiredItemsConst[k]]))) {
                        item.classes[fieldRequiredItemsConst[k]] = 'error';

                        //case fieldRequiredItems is channel_order_item set error folow channel
                        if (fieldRequiredItemsConst[k] === 'channel_order_item') {
                            if (channel_short_name === ListChannelCost.AMAZON_JP.ShortName) {
                                item.classes[fieldRequiredItemsConst[k]] = 'error'
                            } else {
                                item.classes[fieldRequiredItemsConst[k]] = ''
                            }
                        }
                        
                
            } else {
                item.classes[fieldRequiredItemsConst[k]] = ''
            }
        }

        if (!item.classes['item_name']) {
            let ProhibitedKeyWord = itemName.ProhibitedKeyWord;
            if (isArray(ProhibitedKeyWord) && ProhibitedKeyWord.length > 0) {
                item.classes['item_name'] = 'warring';
                item.HasApproveKeyWordBLOrigin = null;
                item.ProhibitedKeyWord = ProhibitedKeyWord;
            }
        }

        return item;
    }
    
    onFocus = (value, column) => {
        let itemData = this.props.itemData;
        if (column === 'origin') {
            let message = ''
            if (value && this.filterOriginExist(value) < 1) {
                message = lang.origin_existed
                this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
            } else {
                this.props.onChange({ value: '', column: 'tooltip' })
            }
            this.props.onChange({ value: message, column: 'message' })
        }

        if (column === 'item_name') {
            this.setState({
                clickInsideItemName: true
            })
        }

        if (column === 'sku' || column === 'item_code' || column === 'channel_order_item' || column === 'item_name') {
            if (value && !regexIsRomanji(value)) {
                let message = lang.prohibited_characters
                this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            } else if (value &&  column === 'item_name') {
                if (itemData.ProhibitedKeyWord && itemData.ProhibitedKeyWord.length > 0) {
                    this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
                    this.props.onChange({ value: itemData.ProhibitedKeyWord, column: 'message' })
                }
                
            }
        }
        if (column === 'sku') {
            if (value.length > this.props.maxSizeSku) {
                let message = lang.size_sku_limit;
                this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
                this.props.onChange({ value: message, column: 'message' })
            } else {
                this.onCheckDumplicate(value, column, 'focus')
            }
        }
        if (column === 'qty' && value === "0") {
            let message = lang.qty_is_0

            this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }

        if (column === 'price_adjusted' && parseFloat(value) === 0) {
            let message = lang.item_value_is_0;

            this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
            this.props.onChange({ value: message, column: 'message' })
        }
    }

    onCheckDumplicate = (value, column, type) => {
        let items = this.props.itemOrder
        let data = this.props.itemData
        let duplicate = 0
        if (!value)
            return;

        let itemsChecks = [];
        for (let j = 0; j < items.length; j++) {
            if (items[j][column]) {
                if (itemsChecks.indexOf(items[j][column]) > -1 && items[j].key === data.key) {
                    if (!duplicate) {
                        if (column === 'sku') {
                            if (type === 'focus') {
                                let message = lang.sku_exist
                                this.props.onChange({ value: column + '_' + this.props.itemData.key, column: 'tooltip' })
                                this.props.onChange({ value: message, column: 'message' })
                            }
                        } else if (column === 'channel_order_item') {
                            items[j][column] = ''
                            alertWarning(lang.channel_code_existed)
                        }
                    }
                    items[j].classes[column] = 'error'
                    duplicate++;
                } else {
                    itemsChecks.push(items[j][column]);
                    items[j].classes[column] = ''
                }
            }
        }

        this.props.onChangeItem(items)
        this.props.onChange({ value: duplicate, column: 'dumplicateValueItem' })
    }

    cancelRowEditOrder = () => {
        this.props.cancelRowEditOrder(this.props.itemData.key)
    }

    async handleSyncCancel() {
        await this.cancelRowEditOrder()
        await this.saveRowItem('checkCancel')
    }

    cancelRow = (data) => {
        if (data) {
            this.handleSyncCancel()
        } else {
            this.removeRowItem(this.props.itemData.key)
        }

        this.clearError()
    }

    buttonRow = (data) => {
        if (!this.props.itemData.save_item) {
            // return (
            //   <div>
            //     <Button onClick={() => this.saveRowItem()}>
            //       <Icon type="save" theme="twoTone" />
            //     </Button>
            //     <Button onClick={() => this.props.pageType === 'editOrder' ? this.cancelRow(this.props.itemData.cancelRow) : this.removeRowItem(this.props.itemData.key)}>
            //       <Icon type="close" />
            //     </Button>
            //   </div>
            // )
            return null
        } else {
            return (
                <Button onClick={() => this.onChange(false, 'save_item')}>
                    <Icon type="edit" theme="twoTone" />
                </Button>
            )
        }
    }

    clickItemName = () => {
        this.asyncClickItem()
    }

    handleClickItemName = () => {
        let data = {
            ChannelID: this.props.order.information.channel_id,
            OrderBy: "ID",
            IsDesc: true,
            PageSize: 1000,
            Page: 1
        }
        this.props.getListItemName(data)
        this.props.onChangeItemName({ value: true, column: 'isLoading' })
        this.props.searchItemCode({ value: true, column: 'search_item_code', rowItem: this.props.itemData.key })
    }

    handleFocusSearch = () => {
        let inputSearch = document.getElementById('input-search-sku-channel-item-code')
        if (inputSearch) {
            inputSearch.focus()
        }
    }

    async asyncClickItem() {
        await this.handleClickItemName()
        await this.handleFocusSearch()
    }

    render() {
        const { save_item } = this.props.itemData
        const { itemData, order, pageType, no, order: { information }, itemOrder } = this.props
        let total_value = OrderHelper.roundNumber(String(itemData.price_adjusted).replace(regexExcludeNumber, '') * String(itemData.qty).replace(regexExcludeNumber, ''))
        let showPaidFlag = false
        if(this.props.order.information.country === 'SG'){
            showPaidFlag = true
        }

        return (
            <tr id="row-item"
                className={(order.rowItemError.indexOf('rowItemError' + itemData.key) !== -1) && itemData.save_item ? 'error-row-item' : (no % 2 === 0 ? 'row-item-even' : null)}
            >
                <td className={"cols-checkbox " + (save_item ? 'save-item-success' : '')}>
                    <Checkbox
                        checked={this.props.itemData.checked}
                        onChange={e => this.onChange(e.target.checked, 'checked')}
                        disabled={save_item || information.status_id === orderStatus.SPLIT}
                    />
                </td>
                <td className={"cols-no " + (save_item ? 'save-item-success' : '')}>
                    <span className='no'>{this.props.no}</span>
                </td>
                <td id='item-sku-infor-order' className={"cols-sku " + (save_item ? 'save-item-success' : '')}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'sku_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            onChange={e => this.onChange(e.target.value, 'sku', this.props.maxSizeSku)}
                            disabled={save_item || information.status_id === orderStatus.SPLIT || information.order_parent_id > 0}
                            className={(save_item ? 'save-item-success' : '') + ' ' + itemData['classes']['sku']}
                            maxLength={this.props.maxSizeSku}
                            value={itemData['sku']}
                            onFocus={(e) => {
                                this.props.validateEmpty(e.target.value, 'sku_' + itemData.key)
                                this.onFocus(e.target.value, 'sku')
                            }}
                            addonBefore={
                                information.status_id === orderStatus.SPLIT || information.order_parent_id > 0 ? (
                                    <Icon type="search" theme="outlined" className="search-icon-disabled" />
                                ) : (<Icon
                                    onClick={() => this.clickItemName()}
                                    type="search" theme="outlined" />)
                            }
                            onBlur={(e) => this.onBlur(e.target.value, 'sku')}
                        />
                    </Tooltip>
                </td>
                <td className={"cols-item-code " + (save_item ? 'save-item-success' : '')}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'item_code_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            onChange={e => this.onChange(e.target.value, 'item_code', 50)}
                            disabled={save_item || (pageType === 'editOrder' && !itemData.addRow) || information.status_id === orderStatus.SPLIT}
                            className={(save_item ? 'save-item-success' : '') + ' ' + itemData['classes']['item_code']}
                            maxLength={50}
                            value={itemData['item_code']}
                            onFocus={(e) => {
                                this.props.validateEmpty(e.target.value, 'item_code_' + itemData.key)
                                this.onFocus(e.target.value, 'item_code')
                            }}
                            onBlur={(e) => this.onBlur(e.target.value, 'item_code')}
                        />
                    </Tooltip>
                </td>
                <td className={"cols-item-name " + (save_item ? 'save-item-success' : '')}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'item_name_' + itemData.key && !itemData.HasApproveKeyWordBLOrigin}
                        title={
                            () => {
                                if (isArray(order.message) && order.tooltip === 'item_name_' + itemData.key)
                                    return <ToolTipWarringProhibited 
                                            onChangeClickInSite={this.onChangeClickInSite}
                                            clickInsideItemName={this.state.clickInsideItemName}
                                            onChange={this.props.onChange}
                                            keywordContains={order.message} 
                                            pageType={this.props.pageType}
                                            itemData={itemData} itemOrder={itemOrder}/>
                                else {
                                    return order.message
                                }
                            } 
                        }
                        overlayClassName={ isArray(order.message) ? 
                            ((itemData.HasApproveKeyWordBL) ? 'tooltip-warring-prohibited-disable': 'tooltip-warring-prohibited') 
                            : 
                            'tooltip-error'}
                    >
                        <Input
                            onChange={e => this.onChange(e.target.value, 'item_name', 250)}
                            disabled={save_item || information.status_id === orderStatus.SPLIT}
                            className={(save_item ? 'save-item-success' : '') + ' ' + itemData['classes']['item_name'] + ' ' + (itemData.HasApproveKeyWordBL ? 'warring-disable' : '') }
                            maxLength={250}
                            value={itemData['item_name']}
                            onFocus={(e) => {
                                this.props.validateEmpty(e.target.value, 'item_name_' + itemData.key)
                                this.onFocus(e.target.value, 'item_name')
                            }}
                            suffix={<Icon type="exclamation"/>}
                            onBlur={(e) => this.onBlur(e.target.value, 'item_name')}
                        />
                    </Tooltip>
                </td>
                {/* <td className="text-center td-discount">
                    { !itemData.is_discount ? '' :
                        <Tooltip
                            title={OrderHelper.item.titleDiscount(itemData.item_value, itemData.price_adjustment, itemData.price_adjusted)}
                        >
                            <i className="fa fa-exclamation-circle icon-price-discount" aria-hidden="true"></i>
                        </Tooltip>
                    }
                </td> */}
                <td id='item-value-infor-order' className={"cols-item-value " + (save_item ? 'save-item-success' : '') + ' item-value'}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'price_adjusted_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <div className="box-price-adjusted">
                            { !itemData.is_discount ? '' :
                                <Tooltip
                                    title={OrderHelper.item.titleDiscount(itemData.item_value, itemData.price_adjustment, itemData.price_adjusted)}
                                >
                                    <Icon type="info-circle" className="icon-pa-price-discount"/>
                                </Tooltip>
                            }
                            <InputFormat
                                onChange={value => this.onChange(value, 'price_adjusted')}
                                value={itemData.price_adjusted}
                                decimal={[10, 2]}
                                onBlur={(value) => this.onBlur(value, 'price_adjusted')}
                                className={(save_item ? 'save-item-success' : '') + ' text-right ' + itemData['classes']['price_adjusted'] + (!itemData.is_discount ? ' ': ' price-adjusted-has-price-discount')}
                                disabled={save_item || information.status_id === orderStatus.SPLIT}
                                isRedstar={false}
                                onFocus={(value) => {
                                    this.props.validateEmpty(value, 'price_adjusted_' + itemData.key)
                                    this.onFocus(value, 'price_adjusted')
                                }}
                                allowNegative={true}
                            />
                        </div>
                        
                    </Tooltip>
                </td>
                <td className={"cols-qty " + (save_item ? 'save-item-success' : '') + ' qty-item'}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'qty_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <InputFormat
                            onChange={(value) => this.onChange(value, 'qty')}
                            value={itemData.qty}
                            decimal={[4, 0]}
                            onBlur={(value) => this.onBlur(value, 'qty')}
                            className={(save_item ? 'save-item-success' : '') + ' text-right ' + itemData['classes']['qty']}
                            disabled={save_item || information.status_id === orderStatus.SPLIT}
                            isRedstar={false}
                            onFocus={(value) => {
                                this.props.validateEmpty(value, 'qty_' + itemData.key)
                                this.onFocus(value, 'qty')
                            }}
                        />
                    </Tooltip>
                </td>
                <td className={"cols-total-value " + (save_item ? 'save-item-success' : '')}>
                    <InputFormat
                        onChange={() => this.onChange({ value: total_value, column: 'total_value' })}
                        className={'total-value text-right' + (save_item ? ' save-item-success' : '')}
                        value={total_value ? total_value : 0}
                        disabled
                        isRedstar={false}
                        allowNegative={true}
                    />
                </td>
                <td className={"cols-origin " + (save_item ? 'save-item-success' : '')}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'origin_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            onChange={e => this.onChange(e.target.value, 'origin', 2)}
                            disabled={save_item || information.status_id === orderStatus.SPLIT}
                            className={(save_item ? 'save-item-success' : '') + ' ' + itemData['classes']['origin']}
                            maxLength={2}
                            value={this.props.itemData['origin']}
                            addonBefore={
                                information.status_id === orderStatus.SPLIT ? (
                                    <Icon type="search" theme="outlined" className="search-icon-disabled" />
                                ) : (
                                        <Icon onClick={() => {this.props.onChange({ value: true, column: 'search_origin' })
                                        this.props.searchItemCode({ value: true, column: 'search_origin', rowItem: this.props.itemData.key })
                                        }}
                                            type="search" theme="outlined"
                                        />
                                    )
                            }
                            onBlur={(e) => this.onBlur(e.target.value, 'origin')}
                            onFocus={(e) => this.onFocus(e.target.value, 'origin')}
                        />
                    </Tooltip>
                </td>
                <td className={"cols-channel-order-item " + (save_item ? 'save-item-success' : '')}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={order.tooltip === 'channel_order_item_' + itemData.key}
                        title={order.message}
                        overlayClassName='tooltip-error'
                    >
                        <Input
                            onChange={e => this.onChange(e.target.value, 'channel_order_item', 60)}
                            disabled={save_item || (pageType === 'editOrder' &&
                                order.manual_flag_bl && !itemData.addRow &&
                                typeof order.channel_order_item_amazon !== "undefined" &&
                                itemData.originAmazon)
                                || itemData.restore
                                || information.status_id === orderStatus.SPLIT
                            }
                            className={(save_item ? 'save-item-success' : '') + ' ' + itemData['classes']['channel_order_item']}
                            maxLength={60}
                            value={this.props.itemData['channel_order_item']}
                            onBlur={(e) => this.onBlur(e.target.value, 'channel_order_item')}
                            onFocus={(e) => {
                                this.onFocus(e.target.value, 'channel_order_item')
                                this.props.validateEmpty(e.target.value, 'channel_order_item_' + itemData.key)
                            }}
                        />
                    </Tooltip>
                </td>
                {
                    showPaidFlag ? 
                    <td className={"cols-checkbox " + (save_item ? 'save-item-success' : '')}>

                            <Checkbox
                                checked={this.props.itemData.gst_paid}
                                onChange={e => this.onChange(e.target.checked, 'gst_paid')}
                                disabled={save_item || information.status_id === orderStatus.SPLIT}
                            />
                    </td>
                    : ""
                }
            </tr>
        )
    }
}

export default RowItemComponent;



// WEBPACK FOOTER //
// ./src/containers/orders/components/items/RowItemComponent.js